<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      合同管理
      <small>/合同审核列表</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">合同审核列表</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
                <div>
                  
              <form  style="margin-top:16px;" >
                <fieldset>
                  <div class="form-group row m-b-15">
                    <label class="col-md-1 col-form-label">合同编号</label>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="合同编号"
                        v-model="contractNo"
                      >
                    </div>

                  <label class="col-md-1 col-form-label">合同标题</label>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="合同标题"
                        v-model="contractTitle"
                      >
                    </div>
                    <label class="col-md-1 col-form-label">时间</label>
                      <div class="col-md-3">
                        <el-date-picker
                          style="width:100%;height:34px;"
                          v-model="TimeValue"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                        ></el-date-picker>
                      </div>
                      <div class="col-md-2"></div>
                    <label class="col-md-1 col-form-label LineSpacing">服务商名称</label>
                    <div class="col-md-2 LineSpacing">
                       <el-select
                          v-model="recomName"
                          style="width:100%;font-size:12px;"
                          clearable
                          filterable
                          placeholder="服务商名称"
                        >
                          <el-option
                            v-for="item in recomNameList"
                            :key="item.recomId"
                            :label="item.recomName"
                            :value="item.recomId"
                          ></el-option>
                        </el-select>
                    </div>
                    <div class="col-md-1 LineSpacing">
                      <a
                        class="btn btn-primary ButtonColor m-r-5"
                        @click="SearchClick()"
                        style="float:right;"
                      >查询</a>
                    </div>
                    <div class="col-md-8"></div>
                    <div class="col-md-11"></div>
                  </div>
                </fieldset>
              </form>
                  <!-- 03 -->
                    <el-table :data="tableData3" style="width: 100%" size="medium" border :header-cell-style="{background:'#ffffff'}" >
                      <el-table-column prop="ordernumber" label="序号"  width="60"  align="center"></el-table-column>
                      <el-table-column prop="contractNo" label="合同编号" align="center"></el-table-column>
                      <el-table-column prop="contractTitle" label="合同标题"  align="center"  show-overflow-tooltip></el-table-column>
                      <el-table-column prop="city" label="合作区域" align="center" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="goodsName" label="合同品类" align="center"></el-table-column>
                      <el-table-column prop="recomTypeName" label="客户类型" align="center"></el-table-column>
                      <el-table-column prop="recomName" label="客户名称" align="center"></el-table-column>
                      <el-table-column prop="contractTerm" label="合同期限" align="center"></el-table-column>
                      <el-table-column prop="inputTime" label="签订时间" align="center" width="160px"></el-table-column>
                      <!-- <el-table-column prop="contractFileUrl" label="合同下载" align="center"></el-table-column> -->
                      <el-table-column prop="currentstatus" label="合同状态" align="center"></el-table-column>
                       <el-table-column label="操作" width="260" align="center">
                         <template slot-scope="scope">
                          <el-button
                            class="btn btn-primary btn-sm ButtonColor"
                            size="small"
                            @click="edit1(scope.row)"
                          >审核</el-button>
                          <el-button
                            @click="handleClick(scope.row,scope.$index+1)"
                            class="btn btn-primary btn-sm ButtonColor"
                            size="small"
                          >详情</el-button>
                            <el-button
                           @click="downloadContract(scope.row)"
                            class="btn btn-primary btn-sm ButtonColor"
                            size="small"
                          >下载合同</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- 04 -->
                  <div class="bottom">
                    <div class="block">
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
      <!-- 审核对话框    嵌套的对话框-->
      <el-dialog title :visible.sync="outerVisible1" :before-close="handleClose1" width="25%">
        <div v-if="EditDialog === 3" class="ModelPadding">
          <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
          <div class="border-main">
            <h5>
              合同的
              <b>时间</b>,
              <b>品类</b>,
              <b>区域</b>,
              <b>金额</b> 您看确定了吗
            </h5>
          </div>
          <div slot="footer" class="dialog-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--cancel btn btn-primary"
                @click="MakeSureEdit('ruleForm')"
                :disabled="disabled"
              >同意审核</button>
            </div>
            <div class="swal-button-container m-l-2">
              <div
                class="swal-button swal-button--cancel btn btn-warning"
                @click="jujue('ruleForm')"
              >拒绝审核</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "contract",
  data() {
    return {
      brandId: "",
      brandName: "",

      citystr: "",
      fileList: [],
      hiddenbutton: "",
      // 合作区域
      typeGoodId: "",
      typeGoodName: "",
      // 上传合同，
      dialogImageUrl: "",
      dialogVisible: false,
      // 对话框
      cityId: 0,
      cityName: "",
      provinceId: 0,
      provinceName: "",
      outerVisible: false,
      outerVisible1: false,
      outerVisible2: false,
      disabled: false,
      TimeValue: "",
      contractNo: "",
      contractTitle:"",
      recomName:"",
      EditDialog: 1,
      CurrentSelection: [],
      contractNo: "",
      pageNo: 1,
      // 当前显示 数据的数据量
      pageSize: 10,
      // 数据总数量  ---- 总条数
      totalCount: 0,
      // 开始时间  （yyyy-MM-dd HH:mm:ss）
      startTime: "",
      // 结束时间  （yyyy-MM-dd HH:mm:ss）
      endTime: "",
      // 新增品类
      GroupList: [
        { key: 2, value: "服务商" },
        { key: 1, value: "分销商" }
      ],
      brnadlist: [],
      // 合同类型
      typeList: [
        { key: 0, value: "服务商" },
        { key: 1, value: "分销商" }
      ],
      // 列表服务商名称
      recomNameList: [],
      addrecomNameList: [],
      //   表格的 数据
      tableData3: [],
      //文件数据
      filedata: [],
      brandvaldata: [],
      director:0
    };
  },
  created() {
    this.initData();
    this.initDatarecomNameList();
    this.initDatabutton();
  },
   mounted() {
  //   if(this.$route.query.director){
  //     this.director = this.$route.query.director;
  //   }
  },
  
  methods: {
    
    // 初始化数据
    initData() {
      //
      let that = this;
      const options = {
        url: "/distribution/B2cTobContractController/selectContractPages",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          director: that.director,
          contractNo: that.contractNo,
          contractTitle: that.contractTitle,
          recomId: that.recomName,
          current: that.pageNo,
          contractStatus:"1",
          size: that.pageSize,
          startContractTerm: that.startTime,
          endContractTerm: that.endTime
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
           that.tableData3 = response.data.data.data.records;
            that.totalCount = response.data.data.data.total;
          for (var i in response.data.data.data.records) {
            response.data.data.data.records[i].ordernumber =
              Number((that.pageNo - 1) * that.pageSize) + Number(i) + 1;
            if (response.data.data.data.records[i].contractStatus === 0) {
              response.data.data.data.records[i].currentstatus = "拒绝审核";
            } else if (response.data.data.data.records[i].contractStatus === 1) {
              response.data.data.data.records[i].currentstatus = "未审核";
            }else if(response.data.data.data.records[i].contractStatus === 2){
                response.data.data.data.records[i].currentstatus = "已审核";
            }
            if(response.data.data.data.records[i].recomType === 1){
                response.data.data.data.records[i].recomTypeName = "服务商";
            }else if(response.data.data.data.records[i].recomType === 0){
                response.data.data.data.records[i].recomTypeName = "分销商";
            }

            if (response.data.data.data.records[i].contractTerm !== null) {
              response.data.data.data.records[i].contractTerm = that.FormatAllDate(
               response.data.data.data.records[i].contractTerm
            ).slice(0,10);
            }else {
                response.data.data.data.records[i].contractTerm = "";
            }
          if (response.data.data.data.records[i].clientSignTime !== null) {
              response.data.data.data.records[i].clientSignTime = that.FormatAllDate(
               response.data.data.data.records[i].clientSignTime
            ).slice(0,10);
            }else {
                response.data.data.data.records[i].clientSignTime = "";
            }
            if (response.data.data.data.records[i].signTime !== null) {
              response.data.data.data.records[i].signTime = that.FormatAllDate(
            response.data.data.data.records[i].signTime
            ).slice(0,10);
            }else {
                response.data.data.data.records[i].signTime = "";
            }    
          }
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },

    proviceChange(val) {
      if (val.length > 0) {
        this.provicedata = val[0].provinceName;
        console.log(this.ruleForm.province)
        let that = this;
        const options = {
          url: "/distribution/B2cRegionalLinkageController/queryCity",
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          // 请求参数
          data: Qs.stringify({
            provinceName: val[0].provinceName
          })
        };
        axios(options).then(response => {
          if (response.data.code == 200) {
            that.citylist = response.data.data;
          } else {
            that.$notify({
              title: "失败",
              message: response.data.message,
              type: "error"
            });
          }
        });
      }
    },

    cityChange(cityval) {
      if (cityval.length > 0) {
        //  console.log(this.ruleForm.city)
      }
    },
    brandChange(brandval) { 
        this.brandvaldata = brandval;
    },

    initbrandData() {
      let that = this;
      const options = {
        url: "/distribution/B2cGoodsInfoController/cascadeQuery",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.brnadlist = response.data.data.brandList;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },

    initproviceData() {
      let that = this;
      const options = {
        // 省
        url: "/distribution/B2cRegionalLinkageController/queryAllProvince",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.contractScopelist = response.data.data;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },

    initcityData() {},
    // 服务商 名称
    initDatarecomNameList() {
      let that = this;
      const options = {
        url: "/distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          //  运营标识：1-运营总监 2-普通运营
          director: that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          this.recomNameList = response.data.data;
          this.addrecomNameList = response.data.data;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    //显示 隐藏   按钮  数据
    initDatabutton() {
      let that = this;
      const options = {
        //  获取当前登录人角色
        url: "/distribution/B2cOrderInfoController/parsingUserTob",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.hiddenbutton = String(response.data.data.roleId);
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    //   列表中的  上传凭证
    uploadPicture(param) {
      this.dialogImageUrl = URL.createObjectURL(param.file);

      const formData = new FormData();
      formData.append("file", param.file);
      this.fileformData = formData;
      let that = this;
      const options = {
        url: "distribution/FileController/uploadFileToFast",
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: that.fileformData
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.ruleForm.fileUrl = response.data.data;
            that.$notify({
              title: "",
              message: response.data.message,
              type: "success"
            });
            setTimeout(() => {
              that.percentage = 100;
              that.percentagestatus = "success";
            }, 100);
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 查询数据
    SearchClick() {
      this.pageNo = 1
      this.initData();
    },
    //  覆盖默认上传行为
    httpRequest(param) {
      this.dialogImageUrl = URL.createObjectURL(param.file);
      let fd = new FormData();
      fd.append("file", param.file);
      let that = this;
      const options = {
        url: "distribution/FileController/uploadFileToFast",
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: fd
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.ruleForm.fileUrl = response.data.data;
            setTimeout(() => {
              that.percentage = 100;
              that.percentagestatus = "success";
            }, 100);
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 拒绝审核
    jujue(formName) {
      this.innerVisible = true;
      this.$prompt("理由：", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /./g,
        inputPlaceholder: "请输入拒绝审核理由",
        inputErrorMessage: "请输入拒绝审核理由"
      })
        .then(({ value }) => {
          let that = this;
          that.disabled = false;
          const options = {
            url: "/distribution/B2cTobContractController/checkContract",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({
              contractId: that.ruleForm.contractId,
              contractStatus: 0,
              contractNo: that.ruleForm.contractNo,
              contractRemark: value
            })
          };
          axios(options)
            .then(function(response) {
              that.outerVisible1 = false;
              that.disabled = false;
              if (response.data.code == 200) {
                that.initData();
                that.$notify({
                  title: "成功",
                  message: "拒绝审核",
                  type: "success"
                });
              } else {
                http.handleEorrorCode(response, that);
              }
            })
            .catch(function(error) {
              that.outerVisible1 = false;
              that.disabled = false;
              http.handleHttpError(error, that);
            });

          this.outerVisible1 = false;
        })
        .catch(() => {
          this.outerVisible1 = true;
        });
    },
    //点击提交 /取消  事件处理函数
    MakeSureEdit(formName) {
      let that = this;
      console.log(that.ruleForm.fileUrl)
      if (this.DialogTitle === "下载合同") {
      } else if (this.DialogTitle === "审核") {
        let that = this;
        that.outerVisible1 = false;
        that.disabled = false;
        const options = {
          url: "/distribution/B2cTobContractController/checkContract",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            contractId: that.ruleForm.contractId,
            contractStatus: '2',
            contractNo: that.ruleForm.contractNo
          })
        };
        axios(options)
          .then(function(response) {
            that.outerVisible1 = false;
            that.disabled = false;
            if (response.data.code == 200) {
              that.initData();
              that.$notify({
                title: "成功",
                message: "审核成功",
                type: "success"
              });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function(error) {
            that.outerVisible1 = false;
            that.disabled = false;
            http.handleHttpError(error, that);
          });
      }
    },

    // 详情的处理函数
    handleClick(row, index) {
      this.$router.push({
        name: "contractdetail",
        path: "/contractdetail",
        query: { contractId: row.contractId, data: JSON.stringify(row) }
      });
    },
    // 审核函数
    edit1(item) {
      this.outerVisible1 = true;
      this.DialogTitle = "审核";
      this.EditDialog = 3;
      this.ruleForm = MethodsBus.cloneRow(item);
    },
    // 下载
    downloadContract(row) {
      if (row.tobFilesList.length > 0) {
        window.open(row.tobFilesList[0].fiteUrl);
         this.$notify({
              title: "成功",
              message: "下载成功",
              type: "success"
            });
      } else {
        this.$notify.error({
          title: "错误",
          message: "请上传合同"
        });
      }
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleClose1(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 对话框的 【确定 】 处理函数
    MakeSure() {
      this.outerVisible = true;
    },
    //   startTime  开始时间
    getstarttime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒

      if (now.getMonth() + 1) {
        if (month < 10) month = "0" + (now.getMonth() + 1);
        date = "0" + "1";
        hour = "0" + "0";
        minu = "0" + "0";
        sec = "0" + "0";
      }
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    // endtime;结束时间
    getEndtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    //  时间的处理函数
    ChangePicker() {
      if (this.TimeValue) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
        console.log(this.startTime);
        console.log(this.endTime);
      } else if (!this.TimeValue) {
        this.startTime = "";
        this.endTime = "";
      }
    },

    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatAllDateadd() {
      this.TimeValue = this.FormatAllDate(this.TimeValue);
    },
    // 分页处理函数 分页-- 获取 每页  value条
    handleSizeChange(value) {
      this.pageSize = value;

      this.pageNo = 1;
      this.initData();
    },
    //  获取 当前  value
    handleCurrentChange(value) {
      this.pageNo = value;
      this.initData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.area {
  margin-right: 50px;
}
.ButtonColor {
  color: #fff !important;
}
.contractScopelist {
  margin-left: -8px;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.InputWidths {
  width: 190px;
}
.remarkInputWidth {
  width: 70%;
}

.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}
.right_one {
  margin-left: 100px;
}
.top-hd {
  margin-top: 20px;
  margin-left: 4%;
}
.text {
  font-size: 14px;
}
.inputclass {
  margin-left: 12%;
}
.table_top {
  margin-top: 6%;
}
.province {
  width: 180px;
}
.city {
  width: 202px;
  margin-left: 20px;
}
.inputclass1 {
  margin-left: 15%;
  width: 133%;
}
.inputclass2 {
  width: 120%;
}
.selectpage {
  display: flex;
  margin-left: 22px;
}
.upload {
  margin-top: 20px;
  margin-left: 18%;
  display: flex;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  justify-content: flex-start;
}
.upload_left {
  /* margin-top: 20px; */
  padding-right: 20px;
  letter-spacing: 1px;
}
.upload_right {
  margin-top: 45px;
}
.item {
  margin-bottom: 18px;
}
.swal-footer {
  text-align: center;
}
.swal-button-container {
  margin-left: 24px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
.remark_u {
  margin-top: 6%;
}
.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}
.remark_s {
  margin-left: -40%;
}
.remark {
  margin-left: 1%;
  margin-top: 20px;
}
.shangchuang {
  margin-left: -13px;
  margin-top: -10px;
}
.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.top-thone {
  margin-left: 20px;
  margin-top: 20px;
}
.btn1 {
  background-color: #fff;
}
.bot-btn {
  float: left;
  margin-left: 8.5%;
}
.bot-btn1 {
  float: right;
  margin-top: 3%;
  margin-right: 3.5%;
}
.bot-btn-left {
  margin-left: 70px;
}
.top-bot {
  float: left;
  margin-left: 4%;
}
.upload_pic {
  margin-left: 2%;
  margin-top: 20px;
}
.a_class {
  padding: 8px 12px;
}

.border-main {
  width: 400px;
  height: 120px;
  margin-left: 9.9%;
}

.border-main > h5 {
  color: #161a1e;
  font-size: 15px;
  margin-top: 15%;
}
.border-main > h5 b {
  color: #e4393c;
}
.d {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/contractReviews.vue